import { FC, MutableRefObject } from 'react'
import { Box, Divider } from '@mui/material'
import { BreakdownBlockRow } from '../../../../common/graphql/__generated__/graphql.autogenerated'
import FinanceBreakdownElement from '../FinanceBreakdownElement/FinanceBreakdownElement'
import { FinanceBreakdownSectionBlock } from '../../../../common/model/Breakdown'
import financeBreakdownSectionStyles from './financeBreakdownSection.styles'

type FinanceBreakdownSectionProps = {
  financeBreakdownSection: BreakdownBlockRow[] | FinanceBreakdownSectionBlock
  index: number
  carGroup?: string
  targetRef?: MutableRefObject<undefined>
  isSecondaryCurrencyDisplay: boolean
}

const FinanceBreakdownSection: FC<FinanceBreakdownSectionProps> = ({
  financeBreakdownSection,
  index,
  targetRef,
  isSecondaryCurrencyDisplay,
  carGroup,
}) => {
  const styles = financeBreakdownSectionStyles()

  return (
    <Box
      className={styles.breakdownSectionContainer}
      data-test={`summary:finance_breakdown_section_${index}`}
    >
      {financeBreakdownSection.map((element, index) => (
        <Box key={element.title}>
          {element.shouldDisplayDivider && (
            <Divider
              className={styles.divider}
              data-test={`summary:finance_breakdown_divider_${index}`}
            />
          )}
          <FinanceBreakdownElement
            key={index}
            carGroup={carGroup}
            element={element}
            index={index}
            targetRef={targetRef}
            isSecondaryCurrencyDisplay={isSecondaryCurrencyDisplay}
          />
        </Box>
      ))}
    </Box>
  )
}

export default FinanceBreakdownSection
